import { utils } from "./FileManagerBrowse.js";

export default class FileManagerBrowseModule {
    constructor(){
        this._fieldConfiguration = [];
        this._fileFilters = {}
        this._currentPage = 1;
        this._fileList = [];
        this._header = [];
        this._currentTotalFiles = 0;
        this._controllers = [];
        this._timeOutFunction = null;
        this._spinnerContainer = 'swlri-file-manager-browse-results-container';
        this._filterPanelOpened = false;
        // read field configuration
        let jsonConf = document.getElementById("swlri-file-manager-conf-field")?.innerText;
        
        if(jsonConf) {
            this._fieldConfiguration = JSON.parse(jsonConf);
        }
    }

    get fieldConfiguration(){
        return this._fieldConfiguration;
    }

    set filterPanelOpened(val){
        this._filterPanelOpened = val;

        window.dispatchEvent(new CustomEvent('swlri-file-manager-browse-toggle-filter-panel', {detail: this._filterPanelOpened}))
    }

    get currentPage(){
        return this._currentPage;
    }

    set currentPage(val){
        this._currentPage = val;
        return this.getFileList();
    }

    set fileFilters(val){
        this._fileFilters = {...val};
        this._currentPage = 1;
        return this.getFileList();
    }

    getFileList(){
        clearTimeout(this._timeOutFunction);
        this._timeOutFunction = setTimeout(()=>{
            let error = '';
            utils.freezeInterface(true,this._spinnerContainer);
            this._getFileList().then((res)=>{
                if(res.success && res?.data?.records && Array.isArray(res.data.records) && res?.data?.header && Array.isArray(res.data.header)){
                    this._fileList = [...res.data.records];
                    this._header = [...res.data.header]
                    this._currentTotalFiles = res.data.totalCount;
                } else {
                    error = 'Cannot load file list';
                    this._fileList = [];
                    this._header = []
                    this._currentTotalFiles = 0;
                }
            }).catch((err)=>{
                if(!err.name == 'AbortError'){
                    error = 'Cannot load file list';
                    this._fileList = [];
                    this._currentTotalFiles = 0;
                    this._header = [];
                    setTimeout(()=>{
                        utils.freezeInterface(false,this._spinnerContainer)
                    },300)
                }
            }).finally(()=>{
                this._timeOutFunction = null;
                let onAbort = this._controllers.filter((c)=>{
                    return c.signal.aborted
                })
                setTimeout(()=>{
                    if(onAbort.length == 0){
                        utils.freezeInterface(false,this._spinnerContainer)
                    }
                    var customEv = new CustomEvent("swlri-file-manager-browse-list-changed")
                    window.dispatchEvent(customEv);
                }, 300)

            })
        },300)

    }

    async _getFileList(){
        if(this._controllers.length){
            this._controllers.forEach((cont)=>{
                cont.abort();
            })
        }

        const control = new AbortController();
        const signal = control.signal;
        this._controllers.push(control)

        let formData = new FormData();
        formData.append("pnum",this._currentPage);
        Object.keys(this._fileFilters).forEach((k)=>{
            formData.append("filters["+k+"]",this._fileFilters[k]);
        })

        const response = await fetch("/wp-admin/admin-ajax.php?"+new URLSearchParams({action: 'list_files_for_browse'}), {
            method: "POST",
            body:formData,
            signal:signal
        })
        this._controllers = [];
        if(!response.ok){
            const resp = response.statusText;
            throw new Error(resp);
        } else { 
            const dataJson = await response.json();
            return dataJson;
        }
    }

}